<template>
  <div>
    <VueSlickCarousel :arrows="true" :dots="true" :adaptiveHeight="true">
      <div v-for="(item, i) of slideList" :key="i">
        <K2Row flex_direction="column" justify_content="center" v-if="item.file">
          <video
            v-if="checkIfVideo(item)"
            class="media-file-video video preview"
            style="max-width: 100%; height: 100%"
            controls
            :src="getImageSource(item, true) || item.file.url || item.url"
            :type="item.file.type || item.file.PostItemFileType"
            controlsList="nodownload"
          ></video>
          <div class="media-file-pdf" v-else-if="item.file.type === 'application/pdf' || item.file.PostItemFileType === 'application/pdf'">
            <pdf
              v-for="i in item.file.numPages"
              :key="i"
              :page="i"
              class="pdf preview"
              :src="getImageSource(item, true) || item.file.url"
              style="max-width: 100%; height: 400px; overflow: auto"
            ></pdf>
          </div>
          <img class="image" v-else height="400px" width="1024px" :src="item.url ? item.url : getImageSource(item)" />
          <div class="carousel__date" v-if="item.date || item.PostItemDate">
            <K2Text style="text-align: center" v-if="item.date">Created on {{ getDate(item.date) }}</K2Text>
            <K2Text style="text-align: center" v-else>Created on {{ getDate(item.PostItemDate) }}</K2Text>
          </div>
        </K2Row>
        <div v-else>
          <video
            v-if="
              item.PostItemFileExt === '.MOV' ||
              item.PostItemFileExt === '.mov' ||
              item.PostItemFileExt === '.mp4' ||
              item.PostItemFileExt === '.avi' ||
              item.type === 'video/mp4' ||
              item.type === 'video/quicktime' ||
              item.type === 'video/avi'
            "
            class="media-file-video video preview"
            style="max-width: 100%; height: 100%"
            controls
            :src="getImageSource(item, true) || item.url || item.FilePath"
            :type="item.type || item.PostItemFileType"
            controlsList="nodownload"
          ></video>
          <div class="media-file-pdf" v-else-if="item.type === 'application/pdf' || item.PostItemFileType === 'application/pdf'">
            <pdf
              v-for="i in item.numPages"
              :key="i"
              :page="i"
              class="pdf preview"
              :src="item.FilePath || item.url"
              style="max-width: 100%; height: 400px; overflow: auto"
            ></pdf>
          </div>

          <img class="image" v-else height="400px" width="1024px" :src="item.url ? item.url : getImageSource(item)" />
          <div class="carousel__date" v-if="item.PostItemDate">
            <K2Text style="text-align: center">Taken on {{ getDate(item.PostItemDate) }}</K2Text>
          </div>
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import uiVariable from '../../config/uiVariable'
import VueSlickCarousel from 'vue-slick-carousel'
import pdf from 'vue-pdf'
import K2Text from '../k2Text/k2Text'
import K2Row from '../k2Row/k2Row'
import { getActivityImageBase } from '@/helper/util_custom'
import { getFormatDate } from '@/helper/utily'

export default {
  name: 'K2Carousel',
  props: ['slideList'],
  watch: {
    slideList: function (value) {
      if (value && value.length > 0) {
        value.forEach(d => {
          if (
            d.type.toLowerCase() === 'video/mp4' ||
            d.PostItemFileType.toLowerCase() === 'video/mp4' ||
            d.type.toLowerCase() === 'video/quicktime' ||
            d.PostItemFileType.toLowerCase() === 'video/quicktime'
          ) {
            this.video = d
          } else {
            this.video = null
          }
        })
      }
    },
  },
  components: { K2Row, K2Text, VueSlickCarousel, pdf },
  data() {
    return {
      uiVariable: uiVariable,
      slide: 0,
      sliding: null,
      video: null,
    }
  },
  mounted() {
    if (this.slideList && this.slideList.length > 0) {
      this.slideList.forEach(d => {
        if (d.type) {
          if (d.type.toLowerCase() === 'video/mp4' || d.type.toLowerCase() === 'video/quicktime') {
            this.video = d
          }
        } else if (d.PostItemFileType) {
          if (d.PostItemFileType.toLowerCase() === 'video/mp4' || d.PostItemFileType.toLowerCase() === 'video/quicktime') {
            this.video = d
          }
        }
      })
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    checkIfImage(file) {
      const fileType = file.type.toLowerCase()
      switch (fileType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/jpg':
        case 'image/gif':
          return true
        // case "video/mp4":
        //     return "video/mp4";
        default:
          return false
      }
    },
    getDate(date) {
      return getFormatDate(date)
    },
    getImageSource(src, isVideo) {
      return getActivityImageBase(src, isVideo)
    },
    getFileExtention(file) {
      const fileName = file.toLowerCase()
      return fileName.split('.')[1]
    },
    checkIfVideo(item) {
      const fileType =
        (item.file.PostItemFileExt && item.file.PostItemFileExt.toLowerCase()) ||
        (this.getFileExtention(item.file) && this.getFileExtention(item.file).toLowerCase())
      switch (fileType) {
        case 'mov':
        case 'mp4':
        case 'avi':
          return true
        // case "video/mp4":
        //     return "video/mp4";
        default:
          return false
      }
    },
  },
}
</script>

<style>
.carousel__date {
  background: var(--bg-grey);
  padding: 3px;
  text-align: center;
  color: var(--text-date);
}
</style>
